import script from "./cloud-alarm-record.vue?vue&type=script&setup=true&lang=js"
export * from "./cloud-alarm-record.vue?vue&type=script&setup=true&lang=js"

import "./cloud-alarm-record.vue?vue&type=style&index=0&id=572549f2&lang=scss&scoped=true"

import exportComponent from "E:\\maoqiaoProjectFile\\monitoring-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-572549f2"]])

export default __exports__